(function () {

  'use strict';

  angular.module('PrintixError', [])

    .constant('PrintixErrorConstants', {
      UNAUTHORIZED: 'unauthorized',
      FOUR_ZERO_THREE: '403',
      FOUR_HUNDRED_FAMILY: 'fourHundredFamily',
      FIVE_HUNDRED_FAMILY: 'fiveHundredFamily',
      DIRECTIVE_TEMPLATE_FAILED: 'directiveTemplateFailed'
    })

    .service('PrintixErrorService', function (
      $rootScope, $filter, PrintixErrorConstants, $ngBootbox, $window
    ) {
      const PrintixErrorServicePrivate = {};
      let showingErrorMessage = false;

      PrintixErrorServicePrivate.showErrorMessage = function (messageErrorObject) {
        showingErrorMessage = true;
        const errorCode = $filter('translate')(messageErrorObject.data.errorCode);
        const endpoint = messageErrorObject.config.url || null;
        const method = messageErrorObject.config.method || null;
        const requestId = messageErrorObject.data.request_id || messageErrorObject.headers()['x-printix-request-id'];
        const date = messageErrorObject.headers().date;
        let supportLinkHtml = '';
        if (endpoint.includes('customerService') && endpoint.includes('ticket')) {
          const helpSupportUrl = "<a href='https://knowledge.kofax.com/cloudservicewebform' target='_blank'>Click here to manually request support</a>";
          supportLinkHtml =
              '<tr>' +
                '<td class="p5" style="vertical-align: top">Request support</td>' +
                '<td class="p5">' + helpSupportUrl + '</td>' +
              '</tr>';
        }
        $ngBootbox.customDialog({
          title: $filter('translate')('UpsSomethingWentWrong'),
          message:
            '<div class="size110">' + errorCode + '</div>' +
            '<table class="size80 mt20">' +
              '<tbody>' +
                '<tr>' +
                  '<td class="p5 width15" style="vertical-align: top">Endpoint</td>' +
                  '<td class="p5">' + endpoint + '</td>' +
                '</tr>' +
                '<tr>' +
                  '<td class="p5" style="vertical-align: top">Method</td>' +
                  '<td class="p5">' + method + '</td>' +
                '</tr>' +
                '<tr>' +
                  '<td class="p5" style="vertical-align: top">Request id</td>' +
                  '<td class="p5">' + requestId + '</td>' +
                '</tr>' +
                '<tr>' +
                  '<td class="p5" style="vertical-align: top">Date</td>' +
                  '<td class="p5">' + date + '</td>' +
                '</tr>' + supportLinkHtml +
              '</tbody>' +
            '</table>',
          buttons: {
            alert: {
              label: $filter('translate')('Close'),
              className: 'btn-danger',
              callback: function () {
                showingErrorMessage = false;
                if (messageErrorObject.data.printixCallback) {
                  messageErrorObject.data.printixCallback();
                }
              }
            }
          }
        });
      };

      PrintixErrorServicePrivate.showDirectiveTemplateError = function () {
        $ngBootbox.customDialog({
          title: $filter('translate')('UpsSomethingWentWrong'),
          message: $filter('translate')('PleaseRefresh'),
          buttons: {
            alert: {
              label: $filter('translate')('Refresh'),
              className: 'btn btn-primary',
              callback: function () {
                $window.location.reload();
              }
            }
          }
        });
      };

      PrintixErrorServicePrivate.showForbiddenMessage = function () {
        showingErrorMessage = true;
        $ngBootbox.customDialog({
          title: $filter('translate')('PERMISSION_DENIED'),
          message: '<div class="text-center pt30 pb30"><i class="icon-ban size500 color-danger"></i> </div>',
          buttons: {
            alert: {
              label: $filter('translate')('Close'),
              className: 'btn-danger',
              callback: function () {
                showingErrorMessage = false;
              }
            }
          }
        });
      };

      $rootScope.$on(PrintixErrorConstants.FOUR_ZERO_THREE, function (event, messageErrorObject) {
        PrintixErrorServicePrivate.showForbiddenMessage();
      });

      $rootScope.$on(PrintixErrorConstants.FOUR_HUNDRED_FAMILY, function (event, messageErrorObject) {
        if (!showingErrorMessage) {
          PrintixErrorServicePrivate.showErrorMessage(messageErrorObject);
        }
      });

      $rootScope.$on(PrintixErrorConstants.FIVE_HUNDRED_FAMILY, function (event, messageErrorObject) {
        if (!messageErrorObject.data.errorCode) {
          messageErrorObject.data.errorCode = 'INTERNAL_SERVER_ERROR';
        }
        if (!showingErrorMessage) {
          PrintixErrorServicePrivate.showErrorMessage(messageErrorObject);
        }
      });

      $rootScope.$on(PrintixErrorConstants.DIRECTIVE_TEMPLATE_FAILED, function (event, messageErrorObject) {
        PrintixErrorServicePrivate.showDirectiveTemplateError();
      });
    })

    .factory('PrintixErrorProvider', function (
      $location, $q, $rootScope, $routeParams, $window, uuid, PrintixErrorConstants
    ) {
      return {
        responseError: function (rejection) {

          let currentVersion = '[appVersion]';
          if (currentVersion !== 'undefined') {
            currentVersion = parseInt(currentVersion);
          }

          if (angular.isObject(rejection.data)) {
            rejection.data = rejection.data || {};
          } else {
            rejection.data = {
              message: rejection.data
            };
          }

          rejection.data.errorCode = rejection.data.errorCode || 'FrontEndRequestError';

          const status = rejection.status;
          switch (true) {
            case status === 400:
            {
              break;
            }
            case status === 401:
            {
              $rootScope.$emit(PrintixErrorConstants.UNAUTHORIZED, rejection);
              break;
            }
            case status === 403:
            {
              // Exception endpoints that will not trigger the global 403 error dialog,
              // as the client code for these endpoints will handle the error.
              const exceptionEndpoints = [
                '/terms-of-service/acknowledgement'
              ];
              const isExceptionEndpoint = exceptionEndpoints.some(function (endpoint) {
                return rejection.config.url.endsWith(endpoint);
              });
              if (!isExceptionEndpoint) {
                rejection.data.errorCode = 'PERMISSION_DENIED';
                $rootScope.$emit(PrintixErrorConstants.FOUR_ZERO_THREE, rejection);
              }
              break;
            }
            case status === 404:
            {
              if (rejection.headers('X-Printix-Resource')) {
                if (rejection.config.url.includes('app/component')) {
                  fetch('/admin/build-version.json?randomUUID=' + uuid.v4())
                    .then(function (response) {
                      response.json()
                        .then(function (data) {
                          let newVersion = null;
                          if (data.version !== 'undefined') {
                            newVersion = parseInt(data.version);
                          }
                          if (newVersion > currentVersion) {
                            $window.location.reload();
                          } else {
                            $rootScope.$emit(PrintixErrorConstants.FOUR_HUNDRED_FAMILY, rejection);
                          }
                        })
                        .catch(function () {
                        });
                    })
                    .catch(function () {
                    });
                } else {
                  // Don't display error if it is from local captions because those are only used for canary branches.
                  if (!rejection.config.url.includes('app/assets/captions')) {
                    $rootScope.$emit(PrintixErrorConstants.DIRECTIVE_TEMPLATE_FAILED, rejection);
                  }
                }
              }
              break;
            }
            case status === 409:
            {
              break;
            }
            case status >= 400 && status <= 499:
            {
              if (!rejection.config.url.includes('https://assets.') && !/genai$/.test(rejection.config.url)) {
                $rootScope.$emit(PrintixErrorConstants.FOUR_HUNDRED_FAMILY, rejection);
              }
              break;
            }
            case status >= 500 && status <= 599:
            {
              // Generative AI chat requests will report errors to the user in the chat window,
              // so we don't want to show an error dialog for those.
              if (rejection.data.errorCode !== 'PRINTER_NOT_MONITORED' && !/genai$/.test(rejection.config.url)) {

                // USE THIS PIECE WHEN MIGRATING FROM GLOBAL ERROR SERVICE TO CALLBACK ERROR DIALOG
                //
                // FIND EXAMPLE IN
                //
                // app/components/printerProperties/printerPropertiesController.js
                // app/components/printerProperties/printerGoProfile/printerGoProfile.directive.js
                // app/directives/error-directive/error.directive.js
                //
                // USE THE BLACKLIST BELOW TO SPECIFY WHAT ROUTES AND QUERYPARAMS TO EXCLUDE FROM THE GLOBAL ERROR SERVICE

                // const blacklistedRoutes = {
                //   '/printerProperties/': [
                //     'printerSection=printixGo'
                //   ]
                // };

                // let showOldErrorModal = true;

                // for (const key in blacklistedRoutes) {
                //   if ($location.absUrl().includes(key) && $location.absUrl().includes(blacklistedRoutes[key])) {
                //     showOldErrorModal = false;
                //   }
                // }

                // if (showOldErrorModal) {
                //   $rootScope.$emit(PrintixErrorConstants.FIVE_HUNDRED_FAMILY, rejection);
                // }

                $rootScope.$emit(PrintixErrorConstants.FIVE_HUNDRED_FAMILY, rejection);
              }
              break;
            }
          }
          return $q.reject(rejection);
        }
      };
    })

    .config(function ($httpProvider) {
      $httpProvider.interceptors.push('PrintixErrorProvider');
    });

})();
